/** Design FTO 可阅读报告的首次任务奖励接入 service。 */
export interface DesignFtoReportOnboardingService {
    /** 初始化当前 Design FTO 报告页面作用域内的奖励能力。 */
    initialize(): Promise<void>;
    /** 通知 service 当前任务已经具备完整可阅读的报告。 */
    notifyReportAvailable(taskId: string): void;
    /** 仅供本地开发环境强制启动权益卡片。 */
    debugStart(taskId: string): void;
    /** 清理领取上下文和权益卡片。 */
    destroy(): void;
}

/** Design FTO 报告 onboarding service 的容器标识。 */
export const DesignFtoReportOnboardingService = Symbol('DesignFtoReportOnboardingService');
